import { FC, memo } from 'react';

import { ShiftFilterForm, IShiftFilterForm } from './ShiftFilterForm';

const ShiftFilter: FC<IShiftFilterForm> = memo((props) => <ShiftFilterForm {...props} />);

export { ShiftFilter };
